export const DEFAULT_LINES = 2;
export const DEFAULT_TAG = 'div';
